import React, { useState } from 'react'
import {
  Button,
  Container,
  ListContainer,
  CarouselCards,
  Tools
} from '@pmi/pmi-iqos-ds-react'
import {
  ProductCard,
  goToRoute,
  Sites,
  analytics,
  cookie
} from '@pmi/pmi-iqos-shared-react'

const LoyaltyProductCard = ({
  alternativeQoins,
  campaignName,
  product,
  translations,
  showVariantList = true,
  productBaseUrl
}) => {
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(
    product.options ? product.selectedOptionIndex || 0 : null
  )

  const handleChangeColor = newSelectedOptionIndex => {
    if (selectedOptionIndex !== newSelectedOptionIndex) {
      setSelectedOptionIndex(newSelectedOptionIndex)
    }
  }

  const getProductUrl = product => {
    const { options, productId } = product
    const { seoName, variantId } = options[selectedOptionIndex]
    return seoName
      ? `${productBaseUrl}${seoName}`
      : `${productBaseUrl}${productId}/${variantId}`
  }

  const handleProductClick = isButtonClicked => {
    if (campaignName) {
      analytics.onClickProductCampaign(
        isButtonClicked,
        product.loyalty.name,
        campaignName
      )
    } else {
      analytics.clickEvent({
        eventCategory: analytics.getEventCategory() || 'Lottery',
        eventLabel: product.loyalty.name,
        user_id: cookie.getSpiceId() || ''
      })
    }

    goToRoute({
      mainPath: getProductUrl(product),
      site: Sites.iqosphere
    })
  }

  const { options } = product
  const { price, listPrice, images, badges, currency, qoins } =
    options[selectedOptionIndex]
  const bazaarVoice = product ? product.bv : null
  const bazaarVoiceProductId = options
    ? options[selectedOptionIndex].bv_id
    : bazaarVoice
    ? bazaarVoice.bv_id
    : null
  const bazaarVoiceShowRating =
    bazaarVoice && bazaarVoice.display_rating === true && bazaarVoiceProductId

  return (
    <ProductCard
      translations={translations}
      href={getProductUrl(product)}
      images={images}
      title={product.name}
      price={price}
      qoins={qoins}
      listPrice={listPrice}
      currency={currency}
      options={options}
      selectedOptionIndex={selectedOptionIndex}
      showVariantList={showVariantList}
      handleOnCardClick={() => {
        handleProductClick(false)
      }}
      handleChangeColor={handleChangeColor}
      testingPrefix="LotteryProductCard"
      alternativeBadge={badges}
      alternativeQoins={alternativeQoins}
      bazaarVoiceProductId={bazaarVoiceShowRating ? bazaarVoiceProductId : null}
      shortDescription={product.options[selectedOptionIndex].shortDescription}>
      <Container pt="4">
        <Button
          text={translations.tk_selectProduct}
          onClickHandler={() => {
            handleProductClick(true)
          }}
        />
      </Container>
    </ProductCard>
  )
}

const LoyaltyProductList = ({
  alternative = false,
  campaignName,
  columns = [1, 2, 3],
  isCarousel = false,
  products,
  translations,
  showVariantList = true,
  productBaseUrl,
  miniPlpAlignment
}) => {
  const renderCards = () => {
    return products.map((product, index) => (
      <Container key={index} display={Container.displays.flex} fullWidth>
        <LoyaltyProductCard
          showVariantList={showVariantList}
          product={product}
          translations={translations}
          noDetailLink={true}
          alternativeQoins={alternative}
          productPosition={index}
          campaignName={campaignName}
          productBaseUrl={productBaseUrl}
        />
      </Container>
    ))
  }
  return isCarousel && !Tools.isDesktop() ? (
    <CarouselCards cards={renderCards()} />
  ) : (
    <ListContainer
      columns={columns}
      xBetween="8"
      yBetween="20"
      fullWidth
      justifyContent={
        miniPlpAlignment === 'center'
          ? Container.justifyContentValues.center
          : Container.justifyContentValues.flexStart
      }>
      {renderCards()}
    </ListContainer>
  )
}

export default LoyaltyProductList
